import React, { ReactNode } from "react";
import { IntlProvider } from "react-intl";
import AppLocale from "@lib/services/localization";
import { useLocaleContext } from "../AppContextProvider/LocaleContextProvider";
import { IntlGlobalProvider } from "@lib/helpers/Common";
import dayjs from "dayjs";

interface AppLocaleProviderProps {
  children: ReactNode;
}

const AppLocaleProvider: React.FC<AppLocaleProviderProps> = (props) => {
  const { locale } = useLocaleContext();
  const currentAppLocale = AppLocale[locale.locale];
  dayjs.locale(locale.locale);

  return (
    <IntlProvider
      locale={currentAppLocale.locale}
      messages={currentAppLocale.messages}
      fallbackOnEmptyString={true}
      onError={(err) => {
        console.log("IntlProvider", err);
      }}
    >
      <IntlGlobalProvider>{props.children}</IntlGlobalProvider>
    </IntlProvider>
  );
};

export default AppLocaleProvider;
